import { render, staticRenderFns } from "./EnergyClaim.vue?vue&type=template&id=07bc36da&scoped=true"
import script from "./EnergyClaim.vue?vue&type=script&lang=js"
export * from "./EnergyClaim.vue?vue&type=script&lang=js"
import style0 from "./EnergyClaim.vue?vue&type=style&index=0&id=07bc36da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc36da",
  null
  
)

export default component.exports